import { getTimestamp, now } from "owa-datetime";
import type { AsyncItemEntry } from "owa-copilot-async-chat-types";

/**
 * Milliseconds the item has been sitting in its current status, as seen by the user this session.
 *
 * Read alongside the `status` logged on the same event, this is the general form of every
 * engagement-latency question: time a `Completed` result went unopened, time an `InputRequired`
 * prompt stayed blocked, or time a `Working` task had been running when the user checked on it.
 *
 * Returns `undefined` when the clock was never started (an entry seeded outside the normal paths),
 * so a missing value is never read as an instant response.
 */
export function getTimeInStatusMs(entry: AsyncItemEntry | undefined): number | undefined {
    if (entry?.statusChangedAtTimestampMs === undefined) {
        return undefined;
    }
    
    return Math.max(0, getTimestamp(now()) - entry.statusChangedAtTimestampMs);
}
